export default class SDKAdapter {
    constructor(sdk) {
        this.sdk = sdk;
    }
    fetch(object) {
        throw new Error('fetch not implemented');
    }
    search(object, query) {
        throw new Error('search not implemented');
    }
    get(object) {
        throw new Error('get not implemented');
    }
    post(object) {
        throw new Error('post not implemented');
    }
    put(object) {
        throw new Error('put not implemented');
    }
    save(object) {
        return this.post(object);
    }
    delete(object) {
        throw new Error('delete not implemented');
    }
}
//# sourceMappingURL=adapter.js.map